/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Fragment } from 'react';
import {
  connectHits,
  connectStateResults,
  connectStats
} from 'react-instantsearch-dom';

import type { SearchPanelHitsProps } from '~/legacy/types';
import { getInsightsFields } from '~/legacy/utils';

const CustomHits = connectStats(
  connectHits(
    connectStateResults(
      ({
        searchResults,
        nbHits,
        hits,
        hitComponent: HitComponent,
        notFoundComponent: NotFoundComponent,
        hitProps = {}
      }: SearchPanelHitsProps) => {
        const { showNbResults = false, showTitle, title } = hitProps;

        return !searchResults ? (
          <></>
        ) : nbHits === undefined || nbHits === 0 ? (
          NotFoundComponent ? (
            <NotFoundComponent />
          ) : (
            <Fragment />
          )
        ) : (
          <>
            {showTitle && title && (
              <span className="search-panel__type">
                <span>{title}</span>
                <span className="text-label">{nbHits} results</span>
              </span>
            )}
            {showNbResults && <span className="text-label">{nbHits} results</span>}
            <>
              {hits.slice(0).map((hit: any, index: number) => (
                <HitComponent
                  {...hit}
                  hit={hit}
                  key={hit.objectID}
                  position={index + 1}
                  insightsFields={getInsightsFields(searchResults, hit)}
                  {...hitProps}
                />
              ))}
            </>
          </>
        );
      }
    )
  )
);

export default CustomHits;
